import { createLogger } from '@telia-ace/edge-log';

const log = createLogger('utils/doNotTrack');

export function doNotTrack() {
  if (
    window.doNotTrack === '1' ||
    navigator.doNotTrack === 'yes' ||
    navigator.doNotTrack === '1' ||
    navigator.msDoNotTrack === '1' ||
    window.external?.msTrackingProtectionEnabled?.()
  ) {
    log.trace(`DoNotTrack setting found: TRUE`);
    return true;
  }
  log.trace(`DoNotTrack setting not found, assume: FALSE`);
  return false;
}
